export const temporaryCategory = { id: 'temp-cat-1', title: 'Temporary Category', isTemporary: true };
export const temporaryCookbook = { id: 'temp-cook-1', title: 'Temporary Cookbook', isTemporary: true };
export const temporaryIngredients = [
    { id: 'temp-ing-1', name: 'Temporary Ingredient', isTemporary: true },
    { id: 'temp-ing-2', name: 'Another Temp Ingredient', isTemporary: true },
    { id: 'temp-ing-3', name: 'Third Temp Ingredient', isTemporary: true }
];

export const temporaryRecipe = {
  id: 'temp-recipe-1',
  name: 'Temporary Recipe',
  cookbookId: 'temp-cook-1',
  pageNumber: '123',
  servingSize: 2,
  categoryIds: ['temp-cat-1'],
  ingredients: [
    { name: 'Temporary Ingredient', amount: 1, unit: 'cup' },
    { name: 'Another Temp Ingredient', amount: 2, unit: 'tbsp' },
    { name: 'Third Temp Ingredient', amount: 1, unit: 'pinch' }
  ],
  isTemporary: true,
};

export const allTemporaryData = {
    category: temporaryCategory,
    cookbook: temporaryCookbook,
    ingredients: temporaryIngredients,
    recipe: temporaryRecipe
};